<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-form label-width="100px">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="筛选员工">
                                <el-select v-model="$parentInfo.Dialog_TeacherShopList.filter.employee_id" placeholder="员工"
                                           clearable
                                           filterable remote
                                           :remote-method="handelSearchByEmployeeName"
                                           @change="handleInfo()">
                                    <el-option
                                            v-for="item in employees"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-table
                        :data="orderTeacherShops"
                        style="width: 100%"
                        size="middle"
                        :height="550"
                >
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table
                                    :data="_.orderBy(props.row.employee_shops, 'id','desc')"
                                    style="width: 100%"
                                    size="middle"
                            >
                                <el-table-column prop="shop_name" label="商品"></el-table-column>
                                <el-table-column prop="serial_id" label="序列号"></el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button size="mini" @click="handleReturn(props.row.id,scope.row.id)">归还</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="ID"></el-table-column>
                    <el-table-column prop="name" label="员工名"></el-table-column>
                    <el-table-column label="操作">
                        <template scope="scope">
                            <el-button size="mini" @click="handleAllReturn(scope.row.id)">全部归还</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="$parentInfo.Dialog_TeacherShopList.currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="$parentInfo.Dialog_TeacherShopList.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialog_GrantShop",
        data() {
            return {
                employeeId:'',
                templateSelection:'',
                employees:[],
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInfo();
            this.handelSearchByEmployeeName();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderTeacherShops: function () {
                return this._.orderBy(this.$parentInfo.Dialog_TeacherShopList.teacherShops, 'id', 'asc');
            }
        },
        methods: {
            handleInfo(currentPage = 1){
                if (currentPage === 1) {
                    this.$parentInfo.Dialog_TeacherShopList.currentPage = 1
                }
                this.$parentInfo.Dialog_TeacherShopList.loading = true;
                this.$axios.get(store.state.server + '/getActiveTeacher?'+
                    'employeeId='+this.$parentInfo.Dialog_TeacherShopList.filter.employee_id +
                    '&page='+this.$parentInfo.Dialog_TeacherShopList.currentPage +
                    '&limit=' + this.$parentInfo.Dialog_TeacherShopList.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$parentInfo.Dialog_TeacherShopList.teacherShops=response.data.content.list
                        this.$parentInfo.Dialog_TeacherShopList.total=response.data.content.total
                        this.$parentInfo.Dialog_TeacherShopList.loading = false;
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleInit(){

            },
            handleChange(){

            },
            handleSelectionChange(index,row) {
                this.templateSelection = row;
            },
            handleSizeChange(val) {
                this.$parentInfo.Dialog_TeacherShopList.currentPageSize = val;
                this.handleInfo(this.$parentInfo.Dialog_TeacherShopList.currentPage, this.$parentInfo.Dialog_TeacherShopList.currentPageSize)
            },
            handleCurrentChange(val) {
                this.$parentInfo.Dialog_TeacherShopList.currentPage = val;
                this.handleInfo(this.$parentInfo.Dialog_TeacherShopList.currentPage, this.$parentInfo.Dialog_TeacherShopList.currentPageSize)
            },

            handelSearchByEmployeeName(val=''){
                this.$axios.get(store.state.server + '/searchByTeacher?employeeName=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.employees=response.data.content.employee
                    }
                })
            },
            handleAllReturn(employee_id){
                let employeeShopIds=[];
                if(this.$parentInfo.Dialog_TeacherShopList.teacherShops[employee_id]){
                    var employee_shops=this.$parentInfo.Dialog_TeacherShopList.teacherShops[employee_id].employee_shops
                    let i=0;
                    for(let item in employee_shops){
                        employeeShopIds[i]=item;
                        i++;
                    }
                }
                this.$axios.post(store.state.server + '/returnByMany',{
                    'employeeShopIds':employeeShopIds
                }).then((response) => {
                    if (response.data.code == '0000') {
                        for(let i=0;i<response.data.content.shops.length;i++){
                            this.$set(this.$parentInfo.teacherDistributions,response.data.content.shops[i].id,response.data.content.shops[i])
                        }
                        this.$delete(this.$parentInfo.Dialog_TeacherShopList.teacherShops,employee_id)
                        this.$message({
                            type: 'success',
                            message: '归还成功'
                        });
                    }
                })
            },
            handleReturn(employee_id,employee_shop_id){
                this.$axios.post(store.state.server + '/returnByOne',{
                    'employeeShopId':employee_shop_id
                }).then((response) => {
                    if (response.data.code == '0000') {
                        this.$set(this.$parentInfo.teacherDistributions,response.data.content.shop.id,response.data.content.shop)
                        if(this.$parentInfo.Dialog_TeacherShopList.teacherShops[employee_id]){
                            this.$delete(this.$parentInfo.Dialog_TeacherShopList.teacherShops[employee_id],employee_shop_id)
                        }
                        this.$message({
                            type: 'success',
                            message: '归还成功'
                        });
                    }
                })
            },
            handleReview(invoiceItem_shop_id){
                this.$axios.post(store.state.server + '/cancelDispatch',{
                    'invoiceItemShopId':invoiceItem_shop_id,
                }).then((response) => {
                    if (response.data.code == '0000') {
                        this.templateSelection=[];
                        this.$set(this.$parentInfo.leaseInventory,response.data.content.shop.id,response.data.content.shop)
                        this.$set(this.$parentInfo.Dialog_TeacherShopList.leaseInvoices,response.data.content.invoice.invoice_id,response.data.content.invoice)
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            }
        }
    }
</script>

<style scoped>

</style>